import ESGLandingPageNew from "../components/esg/ESGLandingPageNew";
 
const EsgMain = () => {
  return (
    <div>
        <ESGLandingPageNew />
    </div>
  )
}
 
export default EsgMain